/** Ephemeral context (versions, view, client) captured when the report form opens, since none of it can be reconstructed later. */

import { platformAppVersion } from '#lib/config.js';
import { locationLabel } from '#lib/apps/types.js';
import { appStore } from '#lib/stores/appStore.svelte.js';
import { geodataStore } from '#lib/stores/geodataStore.svelte.js';
import { mapInstanceStore } from '#lib/stores/mapInstanceStore.svelte.js';
import { versionsStore } from '#lib/stores/versionsStore.svelte.js';
import type { ReportContext } from './issueReporterClient';

export function gatherReportContext(): ReportContext {
	const app = appStore.app;
	const map = mapInstanceStore.map;
	const dataset = app?.datasets[0];
	const activeVersion = dataset ? versionsStore.version(dataset) : undefined;
	const area = locationLabel(geodataStore.summaryData);
	const center = map?.getCenter();

	return {
		...(area ? { area } : {}),
		versions: {
			platform: platformAppVersion,
			app: app?.version,
			data: activeVersion?.version,
			// Methodology follows the data series, mirroring the SafeCurves Method menu.
			methodology: activeVersion && `v${activeVersion.series}`
		},
		view: {
			url: location.pathname + location.search,
			basemap: app?.basemap,
			...(map && center
				? {
						zoom: Math.round(map.getZoom() * 100) / 100,
						center: [center.lng, center.lat] as [number, number],
						bbox: map.getBounds().toArray().flat() as [number, number, number, number]
					}
				: {})
		},
		client: {
			userAgent: navigator.userAgent,
			language: navigator.language,
			timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			viewport: [window.innerWidth, window.innerHeight]
		}
	};
}
